import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isDealRentCianAgency } from './isDealRentCianAgency';

const dealRentLogo = require('../../assets/deal-rent.png');

export const agentImageLink: TComputedPropMapper<string | undefined> = (props, ctx) => {
  const {
    offer: { user },
  } = props;

  if (isDealRentCianAgency(props, ctx)) {
    return dealRentLogo;
  }

  if (user) {
    if (user.masterAgent) {
      return user.masterAgent.absoluteAvatarUrl || undefined;
    }

    return user.agentAvatarUrl || undefined;
  }

  return undefined;
};
